<script setup lang="ts">
import type { AgentReview } from '#shared/agent/types';

const props = withDefaults(
  defineProps<{
    review: AgentReview
    variant?: 'lite' | 'full'
  }>(), {
    variant: 'lite',
  },
);

const { t } = useI18n();
const reviewTitle = computed(() => {
  return props.review.fullName || t(`agent.reviews.anonymous_author`);
});

// NOTE: we don't use IadTitle as font family is the base one
</script>

<template>
  <article
    class="p-m md:w-[calc(50%-0.5rem)] lg:w-[calc(33.33%-0.67rem)] border border-neutral-70 rounded-2xl flex flex-col gap-s w-full"
    :class="{
      'bg-white': variant === 'full',
    }"
  >
    <div class="flex items-center justify-between no-wrap">
      <div>
        <p
          class="text-lg"
          v-text="reviewTitle"
        />
        <IadRating :rating="review.rating" />
      </div>
      <IadTag
        :text="$t(`agent.reviews.tag.${review.type}`)"
        variant="ratings"
      />
    </div>
    <p
      class="text-xl font-bold leading-snug empty:hidden"
      v-text="review.title"
    />
    <IadTextWithOverflow lines="five">
      <p v-text="review.description" />
    </IadTextWithOverflow>
    <p class="mt-auto">
      <small
        class="text-neutral-40"
        v-text="$t(`agent.reviews.reviewed_at`, { date: $d(new Date(review.createdAt)) })"
      />
    </p>
  </article>
</template>
